'use strict';

angular.module('documentsManagement', [  
  'common',
  'ngFileUpload'
]);
